import React, { ChangeEvent, useCallback, useEffect, useState } from "react";
import { Modal, ModalBody } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { ResponseFailModal, ResponseSuccessModal } from "../../components/Commons/ModalResponse";
import TemplateGroupCreate from "../../components/Message/TemplateGroupCreate";
import { useRefresh } from "../../lib/useRefresh";
import { RootState } from "../../stores";
import { addTemplateGroupAction, changeField, changeResult, initialize } from "../../stores/templateGroup";
import { PopupContainerProps } from "../../types/commons";
import { initialize as initializeHeader} from "../../stores/header";
import * as systemApi from "../../api/system";
import { useQuery } from "@tanstack/react-query";

const ModalWrap = styled(Modal)`
.modal-dialog {
  max-width: 900px;
}
`;

const TemplateGroupCreateContainer = ({
  isOpen,
  toggle,
  reload,
}:PopupContainerProps) => {
  const dispatch = useDispatch();
  const { templateGroupItems, templateGroupSuccess, templateGroupError, } = useSelector(({ templateGroup }:RootState) => ({
    templateGroupItems: templateGroup.templateGroup,
    templateGroupSuccess: templateGroup.templateGroupAddSuccess,
    templateGroupError: templateGroup.templateGroupAddError,
  }));
  const [ hotelCodeList, setHotelCodeList ] = useState<any[]>([]);
  const [ popupMessage, setPopupMessage ] = useState<string>('');
  const [ errorModal, setErrorModal] = useState<boolean>(false);
  const [ successModal, setSuccessModal ] = useState<boolean>(false);

  //react-query
  useQuery(['filterSelect'],
    () => systemApi.getCommonCodeList({enabled: true, headYn : false}).then(res => setHotelCodeList(res.data.data.codeList.filter((item:any)=> item.head === 'HT001')))
    ,{
      refetchOnWindowFocus: false, //브라우저로 포커스 이동에 따른 리패치
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleRefresh = useCallback(
    useRefresh((handler) => handler())
  ,[]);

  const handleChange = useCallback((e:ChangeEvent<HTMLInputElement>|ChangeEvent<HTMLSelectElement>) => {
    const { value, name } = e.target;
    dispatch(changeField({
      key: name,
      value: value,
    }));
  },[dispatch]);

  const handleSubmit = useCallback(() => {
    if( templateGroupItems.templateGroup === '' || templateGroupItems.templateGroupName === '') return;
    handleRefresh(() => dispatch(addTemplateGroupAction({...templateGroupItems})));
  },[dispatch, handleRefresh, templateGroupItems]);

  useEffect(() => {
    if(isOpen) dispatch(initialize());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  useEffect(() => {
    if(templateGroupItems.hotelCode === '' && hotelCodeList.length > 0){
      dispatch(changeField({
        key: 'hotelCode',
        value: hotelCodeList[0].detail,
      }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[hotelCodeList]);

  useEffect(() => {
    if(templateGroupSuccess){
      if(templateGroupSuccess === 'DB001'){
        dispatch(changeResult({key: 'templateGroupAddSuccess',value: ''}));
        dispatch(changeResult({key: 'templateGroupAddError',value: null}));
        setPopupMessage('이미 등록된 데이터 입니다.');
        setErrorModal(true);
        return;
      }
      //3000: 파라미터 검증 실패
      if(templateGroupSuccess === 'DB002' || templateGroupSuccess === 'DB003' || templateGroupSuccess === '3000'){
        dispatch(changeResult({key: 'templateGroupAddSuccess',value: ''}));
        dispatch(changeResult({key: 'templateGroupAddError',value: null}));
        setPopupMessage('데이터를 찾을 수 없습니다.');
        setErrorModal(true);
        return;
      }
      if(templateGroupSuccess === '1000'){
        dispatch(changeResult({key: 'templateGroupAddSuccess',value: ''}));
        dispatch(changeResult({key: 'templateGroupAddError',value: null}));
        setPopupMessage('템플릿 그룹 생성이 완료 되었습니다.');
        setSuccessModal(true);

        setTimeout(() => {
          setSuccessModal(false);
          toggle();
          reload && reload();
        },1500);
        return;
      }
    }
    if(templateGroupError){
      const resultCode = templateGroupError.response?.data?.resultCode;
      if(resultCode === 'MC003'||resultCode === 'MC004'||resultCode === 'MC005'||resultCode === 'MC006'||resultCode === 'MC007'||resultCode === 'MC008'){
        dispatch(initializeHeader());
        setPopupMessage('세션이 만료 되었습니다.');
        setErrorModal(true);
        return;
      }
      if(resultCode === '9999'){
        setPopupMessage('Server Error\n새로고침 후 다시 시도해 주십시오.');
        setErrorModal(true);
        return;
      }
      dispatch(changeResult({key: 'templateGroupAddSuccess',value: ''}));
      dispatch(changeResult({key: 'templateGroupAddError',value: null}));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[templateGroupSuccess, templateGroupError]);

  return (
    <>
      <ModalWrap
        show={isOpen}
        onHide={() => toggle()}
        centered
        backdrop='static'
      >
        <ModalBody className='m-3' style={{margin:0, padding:0}}>
          <TemplateGroupCreate 
            hotelCodeList={hotelCodeList}
            templateGroupItems={templateGroupItems}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            toggle={toggle} 
          />
        </ModalBody>
      </ModalWrap>
      {errorModal && 
        <ResponseFailModal
          isOpen={errorModal}
          toggle={()=>setErrorModal(!errorModal)}
          message={popupMessage}
        />}
      {successModal && 
        <ResponseSuccessModal
          isOpen={successModal}
          toggle={toggle}
          message={popupMessage}
          confirm={true}
        />}
    </>
  )
};

export default TemplateGroupCreateContainer;